import React from 'react';
import { BOT_CONV_MESSAGE_TYPE } from '../../consts/common-consts';
import BotMessageFactory from '../messages/bot-message-factory';

/**
 * One turn in the transcript.
 *
 * Both sides are bubbles: the agent gets an outlined card, the visitor a filled
 * accent bubble aligned right. The agent card is wide (long answers need the
 * measure) but still bounded, so a one-line reply does not stretch edge to edge.
 */
export default function ChatMessage(props) {
  const isBot = props.senderType === BOT_CONV_MESSAGE_TYPE;

  if (isBot) {
    return (
      <div className="animate-fade-in-up py-2.5">
        {/* Bounded at 90%: the card should not run the full column width, so
            the transcript keeps a visible ragged edge on both sides. */}
        <div className="w-fit max-w-[90%] rounded-2xl border border-hairline bg-surface px-4 py-3">
          <BotMessageFactory {...props} />
        </div>
      </div>
    );
  }

  // Belt and braces: the payload is normalised upstream, but a bare object
  // reaching a text node throws and takes the whole transcript down with it.
  const text =
    typeof props.message === 'string' ? props.message : JSON.stringify(props.message);

  return (
    <div className="flex animate-fade-in-up justify-end py-2.5">
      <div className="max-w-[85%] rounded-2xl bg-accent px-4 py-2.5 text-[15px] leading-6 text-on-accent">
        <p className="whitespace-pre-wrap break-words">{text}</p>
      </div>
    </div>
  );
}
